import { ComponentSelection } from '@ardoq/component-selection';
import { NavigatorLayoutState } from '../types';
import { navigatorLayoutOperations } from './navigatorLayoutOperations';
import { isTruthy } from '@ardoq/common-helpers';

const updateSelection = (
  state: NavigatorLayoutState,
  { treeSelection: selection, selectionStart }: ComponentSelection
): NavigatorLayoutState => {
  state.tree.syncSelection(selection);
  const newState = {
    ...state,
    selection,
    selectionSize: selection.length,
    selectionStart,
  };
  return navigatorLayoutOperations.treeChanged(newState, {});
};

const componentSelectedReducer = (
  state: NavigatorLayoutState,
  componentId: string | null
): NavigatorLayoutState => {
  if (componentId && componentId === state.tree.selectedContext?.id) {
    return navigatorLayoutOperations.treeChanged(state, {});
  }

  const { tree } = state;
  const selection = [componentId].filter(isTruthy);
  tree.syncSelection(selection);
  if (tree.selectedContext) {
    tree.selectedContext.isSelectedContext = false;
    tree.selectedContext = null;
  }
  if (componentId && tree.hasNode(componentId)) {
    tree.selectedContext = tree.getNode(componentId);
    tree.selectedContext.isSelectedContext = true;
  }
  const newState = {
    ...state,
    selection,
    selectionSize: selection.length,
    selectionStart: componentId || '',
  };
  return navigatorLayoutOperations.treeChanged(newState, {});
};

const setIsAllSelected = (
  state: NavigatorLayoutState,
  isAllSelected: boolean
): NavigatorLayoutState => {
  state.tree.setIsAllSelected(isAllSelected);
  return navigatorLayoutOperations.treeChanged(state, {});
};

export const navigatorSelectionOperations = {
  updateSelection,
  componentSelectedReducer,
  setIsAllSelected,
};
